import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["readOnly", "resizeable", "fieldClassName"];
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Textarea from 'react-textarea-autosize';
import './TextAreaAutoSize.scss';
var style = {
  borderRadius: '2px',
  width: '100%'
};
var TextAreaAutosize = function TextAreaAutosize(_ref) {
  var readOnly = _ref.readOnly,
    resizeable = _ref.resizeable,
    fieldClassName = _ref.fieldClassName,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var className = classNames(fieldClassName, 'TextAreaAutoSize-Container__input', {
    'TextAreaAutoSize-Container__input--disable': readOnly
  }, {
    'TextAreaAutoSize-Container__input--resizeable': resizeable
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Textarea, _extends({}, restProps, {
    style: style,
    readOnly: readOnly
  })));
};
TextAreaAutosize.propTypes = {
  readOnly: PropTypes.bool,
  resizeable: PropTypes.bool,
  fieldClassName: PropTypes.string,
  minRows: PropTypes.number
};
TextAreaAutosize.defaultProps = {
  readOnly: false,
  resizeable: false,
  fieldClassName: '',
  minRows: 1
};
export default TextAreaAutosize;